module.exports = __webpack_public_path__ + "media/components/home/masthead/img/lavakidneys_800x400-0d814ba54f7838e2430405392626c061.jpg";